export const CARD_COLORS = [
  "black",
  "yellow",
  "orange",
  "red",
  "magenta",
  "purple",
  "navy",
  "blue",
  "teal",
  "green",
] as const

export type CardColorType = (typeof CARD_COLORS)[number]

/**
 * Maps from card color names to their rendered color strings.
 * JS copy of the --section-color-* values from colors.css.
 */
export const SECTION_COLOR_MAP: Record<CardColorType, string> = {
  black: "hsl(0, 0%, 13%)",
  red: "hsl(356, 62%, 60%)",
  orange: "hsl(23, 68%, 52%)",
  yellow: "hsl(44, 66%, 49%)",
  green: "hsl(77, 50%, 43%)",
  teal: "hsl(150, 26%, 53%)",
  blue: "hsl(193, 78%, 41%)",
  navy: "hsl(210, 36%, 54%)",
  purple: "hsl(251, 20%, 53%)",
  magenta: "hsl(323, 40%, 46%)",
}

/**
 * Maps from card color names to their light background color strings.
 * JS copy of the --section-color-light-* values from colors.css.
 */
export const SECTION_COLOR_LIGHT_MAP: Record<CardColorType, string> = {
  black: "#dddddd",
  red: "#fdf2f3",
  orange: "#fdeee4",
  yellow: "#fffaeb",
  green: "#eff9d5",
  teal: "#ebf5f1",
  blue: "#e9fbff",
  navy: "#e4edf4",
  purple: "#eeedf4",
  magenta: "#f4e0ec",
}

export const MARK_COLORS = [
  "red",
  "orange",
  "yellow",
  "green",
  "teal",
  "blue",
  "navy",
  "purple",
  "magenta",
] as const

export type MarkColorName = (typeof MARK_COLORS)[number]

/** Text colors, also used for colored underlines. */
export const TEXT_COLOR_MAP: Record<MarkColorName, string> = {
  red: "rgb(216, 90, 98)",
  orange: "rgb(216, 113, 49)",
  yellow: "rgb(207, 163, 42)",
  green: "rgb(133, 164, 55)",
  teal: "rgb(104, 166, 135)",
  blue: "rgb(23, 151, 186)",
  navy: "rgb(95, 138, 180)",
  purple: "rgb(120, 111, 159)",
  magenta: "rgb(164, 70, 128)",
}

export const HIGHLIGHT_COLOR_MAP: Record<MarkColorName, string> = {
  red: "rgb(245, 214, 216)",
  orange: "rgb(247, 225, 212)",
  yellow: "rgb(251, 251, 182)",
  green: "rgb(225, 236, 198)",
  teal: "rgb(207, 227, 217)",
  blue: "rgb(214, 238, 245)",
  navy: "rgb(207, 222, 237)",
  purple: "rgb(217, 212, 237)",
  magenta: "rgb(235, 209, 225)",
}

export const DEFAULT_HIGHLIGHT_COLOR_NAME: MarkColorName = "yellow"
